"use client";

import { ReactNode } from "react";
import { cn } from "@repo/ui/utils";
import { RichTextBodyCopySimple } from "@/components/common/rich-text/rich-text-body-copy-simple.component";

export interface FormFieldGroupProps {
  headline?: string | null;
  description?: unknown;
  numberOfColumns?: number | null;
  children: ReactNode;
}

export const FormFieldGroup = ({
  headline,
  description,
  numberOfColumns,
  children,
}: FormFieldGroupProps) => {
  const hasDescription = Array.isArray(description) && description.length > 0;

  return (
    <div className="flex flex-col">
      {headline && (
        <h3 className="typography-mobile-heading-section desktop:typography-desktop-heading-section text-text-primary mb-6">
          {headline}
        </h3>
      )}

      {hasDescription && (
        <RichTextBodyCopySimple
          richText={description}
          className="typography-body-sm-regular text-text-secondary mb-6"
        />
      )}

      <div
        className={cn("grid gap-x-6 gap-y-4 tablet:gap-y-6", {
          "tablet:grid-cols-2": numberOfColumns === 2,
          "tablet:grid-cols-3": numberOfColumns === 3,
          "tablet:grid-cols-4": numberOfColumns === 4,
        })}
      >
        {children}
      </div>
    </div>
  );
};
